var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedRunner,
                    expression: "selectedRunner",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedRunner = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v("Все курьеры"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.runners, function (runner) {
                  return _c("option", { domProps: { value: runner.id } }, [
                    _vm._v(_vm._s(runner.name)),
                  ])
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-t-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showBackPack,
                    expression: "showBackPack",
                  },
                ],
                attrs: { type: "checkbox", id: "ch_11" },
                domProps: {
                  checked: Array.isArray(_vm.showBackPack)
                    ? _vm._i(_vm.showBackPack, null) > -1
                    : _vm.showBackPack,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.showBackPack,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.showBackPack = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showBackPack = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showBackPack = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "pointer", attrs: { for: "ch_11" } }, [
                _vm._v(
                  "\n              Показать выданые препараты\n            "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("DateSelectProps", {
                ref: "selectedDate",
                attrs: {
                  customShortCutsDates: [
                    { title: "Вчера", increment: "minus", days: 1 },
                  ],
                  disabled: true,
                  useDisabledDates: false,
                  selectedDate: _vm.selectedDate,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Показать",
                  loading: _vm.btnLoading,
                  onClick: _vm.showRecords,
                  className: "btn btn-info",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  on: { click: _vm.printTable },
                },
                [_vm._v("Печать")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { attrs: { id: "printArea" } },
          [
            _vm._l(_vm.backPacks, function (packs, runnerId) {
              return _vm._l(packs, function (pack, i) {
                return _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("h5", [
                      _vm._v(
                        _vm._s(
                          (_vm.sortedRunners[runnerId] &&
                            _vm.sortedRunners[runnerId].name) ||
                            "Без имени"
                        ) +
                          " (" +
                          _vm._s(pack.id) +
                          ") выдан:\n            " +
                          _vm._s(
                            _vm.printDate(pack.created_at, "DD.MM.YYYY HH:mm")
                          ) +
                          " обнулен:\n            " +
                          _vm._s(
                            _vm.printDate(
                              _vm.resetsPacks[pack.id][
                                Object.keys(_vm.resetsPacks[pack.id])[0]
                              ].created_at,
                              "DD.MM.YYYY HH:mm"
                            )
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("table", { staticClass: "table table-sm table-hover" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { attrs: { width: "50" } }),
                          _vm._v(" "),
                          _c("th", [_vm._v("Препарат")]),
                          _vm._v(" "),
                          _vm.showBackPack
                            ? _c("th", { attrs: { width: "100" } }, [
                                _vm._v("Количество"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "100" } }, [
                            _vm._v("Остаток"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          !_vm.showBackPack
                            ? _vm._l(
                                _vm.resetsPacks[pack.id],
                                function (item, i, ind) {
                                  return _c("tr", { key: i }, [
                                    _c("td", [_vm._v(_vm._s(ind + 1))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getItemTitle(
                                            item.drug_id,
                                            pack.id
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.resetsPacks[pack.id][item.drug_id]
                                            .qty
                                        )
                                      ),
                                    ]),
                                  ])
                                }
                              )
                            : _vm._l(pack.items, function (item, i) {
                                return _c("tr", { key: i }, [
                                  _c("td", [_vm._v(_vm._s(i + 1))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.drug.title))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.qty))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.resetsPacks[pack.id][
                                          item.drug_id
                                        ] &&
                                          _vm.resetsPacks[pack.id][item.drug_id]
                                            .qty) ||
                                          0
                                      )
                                    ),
                                  ]),
                                ])
                              }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ])
              })
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }